export { default as Box } from './Box';
export type { Props as BoxProps } from './Box';
export { default as Flex } from './Flex';
export type { Props as FlexProps } from './Flex';
export { default as Text } from './Text';
export type { Props as TextProps } from './Text';
export { default as Heading } from './Heading';
export type { Props as HeadingProps } from './Heading';
export { default as Paragraph } from './Paragraph';
export type { Props as ParagraphProps } from './Paragraph';
export { default as Button } from './Button';
export type { Props as ButtonProps } from './Button';



// WEBPACK FOOTER //
// ../kibble/components/index.ts